import { styled, useTheme } from '@mui/material/styles';

interface StyledLabelProps {
  disabled?: boolean;
}

export const StyledLabel = styled('label')(({ disabled }: StyledLabelProps) => {
  const theme = useTheme();
  return {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.4px',
    marginBottom: theme.spacing(1),
    color: disabled ? theme.palette.action.disabled : theme.palette.text.primary,
  };
});
